/**
 * @deprecated use localStorageService.setItem
 */
export function setItem<T>(key: string, item: T){
  const itemAsString = typeof item === "string" ? item : JSON.stringify(item); //don't stringify a string or you end up with quotes in the string value.
  localStorage.setItem(key, itemAsString);
}

/**
 * @deprecated use localStorageService.getItem
 */
export function getItem(key: string){
  const itemAsString = localStorage.getItem(key);
  return itemAsString;
}

/**
 * @deprecated use localStorageService.getJsonItem
 */
export function getJsonItem<TItemType>(key: string): TItemType | undefined{
  const itemAsString = getItem(key);
  let json;
  if(itemAsString != null){
    json = JSON.parse(itemAsString);
  }
  return json as TItemType;
}
